import Point from 'ol/geom/Point';
import proj4 from 'proj4'
import Feature from 'ol/Feature';
import { Geometry, LineString } from 'ol/geom';
export interface IFeatureClassification {
    text: Feature[];
    poly: Feature[];
}



// Functions related to turning GeoJSON features into OpenLayers features

const epsg3857proj4 = "+proj=merc +a=6378137 +b=6378137 +lat_ts=0 +lon_0=0 +x_0=0 +y_0=0 +k=1 +units=m +nadgrids=@null +wktext +no_defs +type=crs";

const calculateScaleForPoint = (feature: Feature) => {
    const geometry: Geometry = feature.getGeometry() as Geometry;

    let coordinate: Coordinate;

    if (feature.get("type") === 'Point' || feature.get("TYPE") === 'TEXT') {
        const point: Point = geometry as Point;
        coordinate = point.getFirstCoordinate();
    } else if (feature.get("type") === 'LineString') {
        const lineString: LineString = geometry as LineString;
        coordinate = lineString.getCoordinates()[0];
    } else {
        return 1;
    }
    
    const [_, lat] = proj4(epsg3857proj4).inverse(coordinate);
    const latitudeInRadians: number = lat * (Math.PI / 180);
    return 1 / Math.cos(latitudeInRadians);
}

const replacer = (_ , value) => {
    if (!value || !value.geometry) {
        return value;
    }

    let type;
    const rawType = value.type;
    let geometry = value.geometry;
    if (rawType === 1) {
        type = 'MultiPoint';
        if (geometry.length === 1) {
            type = 'Point';
            geometry = geometry[0];
        }
    } else if (rawType === 2) {
        type = 'MultiLineString';
        if (geometry.length === 1) {
            type = 'LineString';
            geometry = geometry[0];
        }
    } else if (rawType === 3) {
        type = 'Polygon';
        if (geometry.length > 1) {
            type = 'MultiPolygon';
            geometry = [geometry];
        }
    }

    return {
        'type': 'Feature',
        'geometry': {
            'type': type,
            'coordinates': geometry,
        },
        'properties': value.tags,
    };
};

const extractTextFeaturesFromFeatureCollection = (featureCollection: Feature[]): IFeatureClassification => {

    const result: IFeatureClassification = featureCollection.reduce((result, feature) => {
        if (feature.get('TYPE') === 'TEXT') {
            result.text.push(feature);
        } else {
            result.poly.push(feature);
        }

        return result;

    }, {text: [], poly: []})

    return result;
}

export const GeoJsonUtils = {
    extractTextFeaturesFromFeatureCollection,
    replacer,
    calculateScaleForPoint
}